import { useContext } from 'react';
import { CountdownContext } from '../../context';
import DownloadPage from './DownloadPage';
import TimeOverPage from './TimeOverPage';

const DefaultPages = () => {
  const countdown = useContext(CountdownContext);
  return countdown > 0 ? <DownloadPage /> : <TimeOverPage />;
};

export default DefaultPages;
